import endpointsList from './endpointsList';

export type WorkspaceDocumentDetailAccessMode = 'editable' | 'readOnly';

export function getWorkspaceDocumentDetailAccessMode(
  documentsTab?: string,
): WorkspaceDocumentDetailAccessMode {
  return documentsTab === 'readOnly' ? 'readOnly' : 'editable';
}

export function getWorkspaceDocumentDetailEndpoints(
  accessMode: WorkspaceDocumentDetailAccessMode,
  workspaceId: string,
  documentId: string,
): {
  metadata: string;
  file: string;
  renditionFile: string;
  detailInfo: string;
} {
  if (accessMode === 'readOnly') {
    return {
      metadata:
        endpointsList.workspaceUploads.getReadOnlyWorkspaceDocumentMetadata(
          workspaceId,
          documentId,
        ),
      file: endpointsList.workspaceUploads.getReadOnlyWorkspaceDocumentFile(
        workspaceId,
        documentId,
      ),
      renditionFile:
        endpointsList.workspaceUploads.getReadOnlyWorkspaceDocumentRenditionFile(
          workspaceId,
          documentId,
        ),
      detailInfo:
        endpointsList.workspaceUploads.getReadOnlyWorkspaceDocumentDetailInfo(
          workspaceId,
          documentId,
        ),
    };
  }

  return {
    metadata: endpointsList.workspaceUploads.getWorkspaceDocumentMetadata(
      workspaceId,
      documentId,
    ),
    file: endpointsList.workspaceUploads.getWorkspaceDocumentFile(
      workspaceId,
      documentId,
    ),
    renditionFile:
      endpointsList.workspaceUploads.getWorkspaceDocumentRenditionFile(
        workspaceId,
        documentId,
      ),
    detailInfo: endpointsList.workspaceUploads.getWorkspaceDocumentUpdateInfo(
      workspaceId,
      documentId,
    ),
  };
}
